@if (isRequestHeaderUiEnhancementEnabled()) {
  @let showCustomToggleButton = !rawCollaborators().length;
  @let inAddMode = showCustomToggleButton || isInAddMode();
  @let canViewCollaborators = !!rawCollaborators().length && !inAddMode;

  <div class="flex items-center gap-sm">
    <lib-user-dropdown-view
      [userCount]="rawCollaborators().length"
      [userTableList]="rawCollaborators()"
      [userDropdownList]="
        inAddMode ? lookupDropdownList() : collaboratorDropdownList()
      "
      [isDropdownLoading]="
        inAddMode ? isLookupLoading() : isAssignedListLoading()
      "
      [currentDropdownPage]="
        inAddMode ? lookupListCurrentPage() : assignedListCurrentPage()
      "
      [totalDropdownPages]="
        inAddMode ? lookupListTotalPages() : assignedListTotalPages()
      "
      [totalDropdownCount]="inAddMode ? localLookupCount() : assignedListItems()"
      [containerRef]="'request-view-stepper'"
      [showIndividualAvatar]="!rawCollaborators().length"
      [allowLeftPositioning]="true"
      [enableDropdownIcon]="!!rawCollaborators().length"
      [allowCustomToggleButton]="showCustomToggleButton"
      [enableAddItem]="inAddMode"
      [disableAddItem]="isAddingCollaborator()"
      (addItem)="onAddCollaborator($event)"
      [enableDeleteItem]="canViewCollaborators"
      [searchLabel]="'dropdown_search_find_users_label' | transloco"
      [searchPlaceholder]="'search_by_name_placeholder' | transloco"
      [headerListLabel]="
        (inAddMode
          ? 'request_screen_add_collaborators_button_label'
          : 'request_screen_collaborators_section_title'
        ) | transloco
      "
      [noSearchResultLabel]="'no_search_result_label' | transloco"
      [croppedNumber]="4"
      [trimLength]="18"
      [toggleContainerClass]="'gap-sm w-auto'"
      (deleteItem)="deleteCollaborator.emit($event)"
      (handleMenuToggle)="
        inAddMode ? getLookupDropdown($event) : getCollaboratorsDropdown($event)
      "
      (openedMenu)="onDropdownOpenStateChange($event)">
      @if (showCustomToggleButton) {
        <div custom-list-toggle-button class="w-full flex">
          <p
            id="add_collaborator_button"
            class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium">
            <lib-add-icon [iconClass]="'size-4 text-primary-500 me-sm'" />
            {{ 'request_screen_add_collaborators_button_label' | transloco }}
          </p>
        </div>
      }

      @if (canViewCollaborators) {
        <div additional-menu-overlay-actions class="w-full">
          <button
            type="button"
            id="add_collaborator_icon_button"
            class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium"
            (click)="switchToAddMode()">
            <lib-add-icon [iconClass]="'size-4 text-primary-500 me-sm'" />
            {{ 'request_screen_add_collaborators_button_label' | transloco }}
          </button>
        </div>
      }
    </lib-user-dropdown-view>
  </div>
} @else {
  <section class="flex flex-col gap-md w-[11.375rem]">
    <div class="flex items-center justify-between">
      <h4 class="font-medium text-sm text-neutral-900">
        {{ 'request_screen_collaborators_section_title' | transloco }}
      </h4>

      @if (rawCollaborators().length) {
        <button
          type="button"
          id="add_collaborator_icon_button"
          class="bg-transparent border-none"
          (click)="openAssignCollaboratorsDialog.emit()">
          <lib-add-icon [iconClass]="'size-5 text-primary-500'" />
        </button>
      }
    </div>

    @if (!rawCollaborators().length) {
      <button
        type="button"
        id="add_collaborator_button"
        class="bg-primary-50 text-primary-500 font-medium text-sm px-lg py-sm rounded-sm flex gap-sm items-center"
        (click)="openAssignCollaboratorsDialog.emit()">
        <lib-add-icon [iconClass]="'size-5 text-primary-500'" />
        {{ 'request_screen_add_collaborators_button_label' | transloco }}
      </button>
    } @else {
      <lib-user-dropdown-view
        [userCount]="rawCollaborators().length"
        [userTableList]="rawCollaborators()"
        [userDropdownList]="collaboratorDropdownList()"
        [isDropdownLoading]="isAssignedListLoading()"
        [currentDropdownPage]="assignedListCurrentPage()"
        [totalDropdownPages]="assignedListTotalPages()"
        [totalDropdownCount]="assignedListItems()"
        [containerRef]="'request-view-stepper'"
        [showIndividualAvatar]="false"
        [searchLabel]="'dropdown_search_find_users_label' | transloco"
        [searchPlaceholder]="'search_by_name_placeholder' | transloco"
        [headerListLabel]="
          'request_screen_collaborators_section_title' | transloco
        "
        [noSearchResultLabel]="'no_search_result_label' | transloco"
        [enableDeleteItem]="true"
        [croppedNumber]="4"
        [trimLength]="18"
        (deleteItem)="deleteCollaborator.emit($event)"
        (handleMenuToggle)="getCollaboratorsDropdown($event)" />
    }
  </section>
}
